import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    connect() {
        let interval = this.element.dataset.interval || 5

        setTimeout(this.fetch.bind(this), interval * 1000);
    }

    fetch() {
        const callback = this.element.dataset.callback
        fetch(this.element.dataset.url, {
            method: 'GET',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        })
            .then(response => {
                if (!response.ok) {
                    this.element.remove()
                    return
                }
                return response.text()
            })
            .then(html => {
                if (!html) return
                const template = document.createElement('template')
                template.innerHTML = html.trim()

                this.element.replaceWith(template.content)

            }).then(() => {
            if (callback) {
                this.runCallback(callback)
            }
        })
    }
    runCallback(callback) {
        eval(callback)
    }
}

